
export default {
  emits: ['closeCardPopup'],
  props: {
    vacancy: {
      type: Object,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    experience: {
      type: String,
      required: false,
    },
    salary: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    employment: {
      type: String,
      required: false,
    }
  },
  methods: {
    closePopup() {
      this.$emit('closeCardPopup')
    },
    requestCall: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          type: 'Вакансия',
          title: 'Оставить заявку на вакансию',
          message: `Вакансия: ${ this.title }`,
          hideMessage: true,
          hideTabs: true,
          customNotification: `Ваш отклик успешно отправлен. <span>В течение дня с вами свяжется специалист по подбору персонала.</span>`,
        }
      });
    },
  }
}
